module.exports = __webpack_public_path__ + "media/bootstrap-icons/calendar-day-fill-e7fa5dfd.svg";